// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js?{modifyVars:{\"font-size-base\":\"12px\",\"font-family\":\"微软雅黑\"}}!./index.less");
if(typeof content === 'string') content = [[module.id, content, '']];
// add the styles to the DOM
var update = require("!../../../../style-loader/addStyles.js")(content, {});
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(module.hot) {
	// When the styles change, update the <style> tags
	if(!content.locals) {
		module.hot.accept("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js?{modifyVars:{\"font-size-base\":\"12px\",\"font-family\":\"微软雅黑\"}}!./index.less", function() {
			var newContent = require("!!../../../../css-loader/index.js!../../../../less-loader/dist/cjs.js?{modifyVars:{\"font-size-base\":\"12px\",\"font-family\":\"微软雅黑\"}}!./index.less");
			if(typeof newContent === 'string') newContent = [[module.id, newContent, '']];
			update(newContent);
		});
	}
	// When the module is disposed, remove the <style> tags
	module.hot.dispose(function() { update(); });
}


//////////////////
// WEBPACK FOOTER
// ./~/antd/lib/message/style/index.less
// module id = 9
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 30 31 32 33 34 35 36 37 38 39 40 41 42 43 44 45 46 47 48 49 50 51 52 53 54 55 56 57 58 59 61 64 65 66 67 68 69 70 71 72 73 74 75 76 77 78 80